export const GET_APPOINTMENT_DETAIL = "GET_APPOINTMENT_DETAIL"
export const GET_APPOINTMENT_DETAIL_FAIL = "GET_APPOINTMENT_DETAIL_FAIL"
export const GET_APPOINTMENT_DETAIL_SUCCESS = "GET_APPOINTMENT_DETAIL_SUCCESS"
export const GET_APPOINTMENT_DETAIL_RESET = "GET_APPOINTMENT_DETAIL_RESET"

export const getAppointmentDetail = (params) => {
    return { type: GET_APPOINTMENT_DETAIL, params }
}
export const getAppointmentDetailFail = (response) => {
    return { type: GET_APPOINTMENT_DETAIL_FAIL, response }
}
export const getAppointmentDetailSuccess = (response) => {
    return { type: GET_APPOINTMENT_DETAIL_SUCCESS, response }
}
export const getAppointmentDetailReset = () => {
    return { type: GET_APPOINTMENT_DETAIL_RESET }
}